import { render, staticRenderFns } from "./CompanySwitcher.vue?vue&type=template&id=ae7f9294&scoped=true"
import script from "./CompanySwitcher.vue?vue&type=script&lang=js"
export * from "./CompanySwitcher.vue?vue&type=script&lang=js"
import style0 from "./CompanySwitcher.vue?vue&type=style&index=0&id=ae7f9294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7f9294",
  null
  
)

export default component.exports